
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/industries/financial-services",
      function () {
        return require("private-next-pages/solutions/industries/financial-services.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/industries/financial-services"])
      });
    }
  